import React from "react";
import textWeight from "../../utils/textWeight";
import { useWindowWidth } from "../../utils/helpers";
import { ReactSVG } from "react-svg";
import { Loader } from "../index";

const Button = ({
  text,
  bgColor = "bg-primary",
  weight,
  color = "text-white",
  className,
  onClick,
  textSize,
  isDisabled = false,
  icon,
  iconClassName = "",
  type,
  loading,
  isprimary,
  hover,
}) => {
  const { TextWeight } = textWeight();
  const width = useWindowWidth();

  return (
    <button
      style={{
        fontSize: width > 640 ? textSize : textSize - 2,
        fontFamily: weight ? weight : TextWeight.Onest_regular,
      }}
      type={type}
      className={`flex justify-center items-center transition-all duration-300 ease-in-out px-20 py-2 lg:px-24 lg:py-3 rounded-lg border ${
        isDisabled ? "opacity-50 cursor-not-allowed" : `cursor-pointer ${hover}`
      } ${bgColor} ${color} ${
        weight ? weight : TextWeight.Onest_regular
      }  ${className}`}
      onClick={onClick}
      disabled={isDisabled || loading}
    >
      {loading ? (
        <Loader isprimary={isprimary} />
      ) : (
        <>
          {icon && <ReactSVG src={icon} className={iconClassName} />}
          {text}
        </>
      )}
    </button>
  );
};

export default Button;
